import { podcastAPI } from "../../lib/api";
import type { PodcastResponse } from "../../types/api";

export interface DashboardPodcast extends PodcastResponse {
  organizationId: string;
  organizationName: string;
}

export interface DashboardData {
  podcasts: DashboardPodcast[];
}

/**
 * Loads all podcasts across the user's organizations for the dashboard.
 * Requires the user's organization list to be passed via the auth context,
 * so we read it from localStorage where the auth provider persists it.
 */
export async function dashboardLoader(): Promise<DashboardData> {
  // Read user data from localStorage (same source as useAuth)
  const stored = localStorage.getItem("user");
  if (!stored) {
    return { podcasts: [] };
  }

  let user: { organizations?: Array<{ id: string; name: string }> };
  try {
    user = JSON.parse(stored);
  } catch {
    return { podcasts: [] };
  }

  const orgs = user.organizations ?? [];
  if (orgs.length === 0) {
    return { podcasts: [] };
  }

  const results = await Promise.all(
    orgs.map(async (org) => {
      try {
        const podcasts = await podcastAPI.getAll(org.id);
        return podcasts.map((p) => ({
          ...p,
          organizationId: org.id,
          organizationName: org.name,
        }));
      } catch {
        return [] as DashboardPodcast[];
      }
    }),
  );

  return { podcasts: results.flat() };
}
